import { render, staticRenderFns } from "./inventory_list.vue?vue&type=template&id=7ca87966&scoped=true"
import script from "./inventory_list.vue?vue&type=script&lang=js"
export * from "./inventory_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ca87966",
  null
  
)

export default component.exports